import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { Root, List, Trigger, Content } from '@radix-ui/react-tabs';

const Tabs = /*#__PURE__*/forwardRef(function Tabs(props, ref) {
  const {
    id,
    defaultId,
    children,
    onChange,
    orientation = 'horizontal',
    ...otherProps
  } = props;
  const className = cn('yt-tabs', `yt-tabs--${orientation}`, {
    'flex w-full': orientation === 'vertical'
  }, props.className);
  return createElement(Root, Object.assign({}, otherProps, {
    className: className,
    "data-taco": "tabs",
    defaultValue: defaultId,
    dir: "ltr",
    onValueChange: onChange,
    orientation: orientation,
    ref: ref,
    value: id
  }), children);
});
const TabList = /*#__PURE__*/forwardRef(function Tab(props, ref) {
  const className = cn('yt-tab__list border-b border-grey-light flex flex-row m-0 mb-4', props.className);
  return createElement(List, Object.assign({}, props, {
    className: className,
    ref: ref
  }));
});
const TabTrigger = /*#__PURE__*/forwardRef(function Tab(props, ref) {
  const {
    id,
    disabled,
    ...otherProps
  } = props;
  const className = cn('yt-tab bg-transparent border-b-2 border-transparent text-grey-darkest m-0 py-2 px-4', disabled ? 'cursor-not-allowed !text-grey-darker' : 'cursor-pointer rounded-t hover:border-grey-dark aria-selected:border-blue aria-selected:text-black aria-selected:hover:border-blue-light hover:text-black active:yt-focus active:border-blue focus:yt-focus focus:border-blue', props.className);
  return createElement(Trigger, Object.assign({}, otherProps, {
    className: className,
    disabled: disabled,
    ref: ref,
    style: {
      transition: 'border 0.2s ease-in'
    },
    value: id
  }));
});
const TabContent = /*#__PURE__*/forwardRef(function Tab(props, ref) {
  const {
    id,
    ...otherProps
  } = props;
  const className = cn('yt-tab__panel outline-none', props.className);
  return createElement(Content, Object.assign({}, otherProps, {
    className: className,
    ref: ref,
    value: id
  }));
});
Tabs.List = TabList;
Tabs.Trigger = TabTrigger;
Tabs.Content = TabContent;

export { Tabs };
//# sourceMappingURL=Tabs.js.map
